import { transport } from 'config/transport';

export function callApiSaveChiMamNon(congDoanId, month, year, body) {
    return transport.post(`/mamnon/${congDoanId}/thuchi/chimamnon`, body, { params: { month, year } });
}
